export class IndicatorModel {
cmbIndicator: string;
setValue(res){
if(res){
if(res['cmbIndicator']){this.cmbIndicator = res['cmbIndicator'];}
}
}
}